module.exports = "<invoice-items-page></invoice-items-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/invoiceItems.html
// module id = 1738
// module chunks = 0